export type SocialMediaPlatform = 'facebook' | 'instagram' | 'tiktok';

const PLATFORM_DOMAINS: Record<SocialMediaPlatform, string> = {
  facebook: 'facebook.com',
  instagram: 'instagram.com',
  tiktok: 'tiktok.com'
};

export const isValidSocialMediaUrl = (
  value: string,
  platform: SocialMediaPlatform
): boolean => {
  if (!value.trim()) {
    return true;
  }

  try {
    const url = new URL(value.trim());
    const platformDomain = PLATFORM_DOMAINS[platform];
    const hostname = url.hostname.toLowerCase();

    return (url.protocol === 'https:' || url.protocol === 'http:')
      && !url.username
      && !url.password
      && !url.port
      && (hostname === platformDomain || hostname.endsWith(`.${platformDomain}`));
  } catch {
    return false;
  }
};
